// Function to save previous page URL to localStorage
function savePreviousPageUrl() {
  // Get the current pathname from localStorage (this will become the previous URL)
  const currentPath = localStorage.getItem('currentPageUrl');
  
  // If there's a current path stored, save it as the previous URL
  if (currentPath && currentPath !== window.location.pathname) {
    localStorage.setItem('previousPageUrl', currentPath);
  }
  
  // Save the current page pathname
  localStorage.setItem('currentPageUrl', window.location.pathname);
}

// Function to get previous page URL from localStorage
function getPreviousPageUrl() {
  return localStorage.getItem('previousPageUrl') || '/';
}

// Save previous page URL when page loads
savePreviousPageUrl();

// Also save when page visibility changes (for better tracking)
document.addEventListener('visibilitychange', function() {
  if (!document.hidden) {
    savePreviousPageUrl();
  }
});